import React from 'react';
import Popover from 'react-popover';
import KeyHandler from 'react-key-handler';
import _ from 'lodash';
type PopoverWithEscKeyProps = {
  isOpen?: boolean;
  body: React.ReactNode;
  className?: string;
  preferPlace?: string;
  place?: string;
  onOuterAction?: (...args: any[]) => any;
};
const PopoverWithEscKey: React.SFC<PopoverWithEscKeyProps> = props => {
  const {
    isOpen,
    body,
    className = '',
    preferPlace = 'below',
    place = 'below',
    onOuterAction,
  } = props;
  return (
    <Popover
      isOpen={isOpen}
      body={body}
      className={className}
      preferPlace={preferPlace}
      place={place}
      onOuterAction={onOuterAction}
    >
      <span>
        <KeyHandler
          keyEventName="keydown"
          keyValue="Escape"
          onKeyHandle={() => (isOpen ? onOuterAction() : _.noop)}
        />
        {props.children}
      </span>
    </Popover>
  );
};
export default PopoverWithEscKey;
